export const ACCESS_TOKEN_KEY = "HajYYatdg_sisnobe";
export const REFRESH_TOKEN_KEY = "Jkapwy617_sisnobe";
export const USER_INFO_KEY = "Kdjtqyyak_sisnobe";

export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = 'http://localhost:8080/';
export const BASE_API = BASE_URL + "api/v1/";

export const darkColor = '#2b334c';
export const lighGrayColor = '#fbfbfb';